import { createSlice } from '@reduxjs/toolkit';

// We persist user info so we can show UI state on reload.
// The actual token will be fetched via silent refresh on app load if missing.
const loadInitialState = () => {
  try {
    const userRaw = localStorage.getItem('user');
    if (userRaw) {
      return {
        token: null,
        user: JSON.parse(userRaw),
        isInitialized: false
      };
    }
  } catch {
    // ignore
  }
  return { token: null, user: null, isInitialized: false };
};

const initialState = loadInitialState();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action) {
      const { token, user } = action.payload;
      state.token = token ?? null;
      if (user) {
        state.user = user;
        localStorage.setItem('user', JSON.stringify(user));
      }
      state.isInitialized = true;
    },
    setAccessToken(state, action) {
      state.token = action.payload;
      state.isInitialized = true;
    },
    clearCredentials(state) {
      state.token = null;
      state.user = null;
      state.isInitialized = true;
      localStorage.removeItem('user');
    },
  },
});

export const { setCredentials, setAccessToken, clearCredentials } = authSlice.actions;
export default authSlice.reducer;
